class LocalizationDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.js-localization-drawer-overlay');
    this.inner = this.querySelector('.localization-drawer__inner');
    this.closeButtons = this.querySelectorAll('.js-localization-drawer-close');
    this.form = this.querySelector('form');
    this.countrySelect = this.querySelector('#CountryCode');
    this.languageSelect = this.querySelector('#LanguageCode');
    this.languageData = this.parseLanguageData();

    this.bindEvents();
  }

  parseLanguageData() {
    const script = this.querySelector('[data-localization-languages]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Localization drawer: invalid languages data', error);
      return null;
    }
  }

  bindEvents() {
    if (this.closeButtons) {
      this.closeButtons.forEach(btn => btn.addEventListener('click', this.close.bind(this)));
    }
    if (this.overlay) {
      this.overlay.addEventListener('click', this.close.bind(this));
    }

    if (this.countrySelect) {
      this.countrySelect.addEventListener('change', this.updateLanguages.bind(this));
    }

    // Optional: Submit form automatically when changing selects, or keep the CONFIRM AND CLOSE button
    // The design shows a CONFIRM AND CLOSE button, so we let the form submit handle it.
  }

  // Repopulates the language select with the languages of the picked country's market,
  // so they are visible before the market switch happens.
  updateLanguages() {
    if (!this.languageData || !this.countrySelect || !this.languageSelect) return;

    const isoCodes = (this.languageData.countries || {})[this.countrySelect.value];
    if (!isoCodes || isoCodes.length === 0) return;

    const previous = this.languageSelect.value;
    const names = this.languageData.names || {};
    this.languageSelect.replaceChildren(
      ...isoCodes.map(iso => new Option(names[iso] || iso, iso))
    );
    // Keep the current language when the market offers it, otherwise fall back to its first one
    this.languageSelect.value = isoCodes.includes(previous) ? previous : isoCodes[0];
  }

  open() {
    this.classList.remove('invisible', 'pointer-events-none');

    // Force reflow
    void this.offsetWidth;

    this.overlay.classList.remove('opacity-0', 'pointer-events-none');
    this.overlay.classList.add('opacity-100', 'pointer-events-auto');

    this.inner.classList.remove('translate-y-full', 'md:translate-x-full');
    this.inner.classList.add('translate-y-0', 'md:translate-x-0');

    document.body.classList.add('overflow-hidden');

    if (!this.focusTrap && window.FocusTrap) {
      this.focusTrap = new FocusTrap(this, {
        onEscape: this.close.bind(this)
      });
    }
    if (this.focusTrap) this.focusTrap.activate();
  }

  close() {
    this.overlay.classList.remove('opacity-100', 'pointer-events-auto');
    this.overlay.classList.add('opacity-0');

    this.inner.classList.remove('translate-y-0', 'md:translate-x-0');
    this.inner.classList.add('translate-y-full', 'md:translate-x-full');

    setTimeout(() => {
      this.classList.add('invisible', 'pointer-events-none');
      document.body.classList.remove('overflow-hidden');
      if (this.focusTrap) this.focusTrap.deactivate();
    }, 300);
  }
}

if (!customElements.get('localization-drawer')) {
  customElements.define('localization-drawer', LocalizationDrawer)
}
